import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@ngneat/transloco';

@Pipe({
    name: 'size',
    pure: true
})
export class SizePipe implements PipeTransform {
    sizeIndex: number[] = [];
    sizeArray: string[];

    constructor() {
        this.sizeIndex['o'] = 0;
        this.sizeIndex['Ko'] = 1;
        this.sizeIndex['Mo'] = 2;
        this.sizeIndex['Go'] = 3;
        this.sizeIndex['To'] = 4;
        this.sizeIndex['Po'] = 5;
        this.sizeArray = translate('o Ko Mo Go To Po').split(' ');
    }

    /**
     *
     * @param value: string
     *
     */
    transform(
        value: string
    ): string {
        return this.sizeArray[this.sizeIndex[value]];
    }
}
